import { useState } from 'react';
import { useUpdateEffect } from '../../../tools';
import { Control } from '../../layout';
import { FontInput } from './FontInput';
import type { FontAsset, FontSchema } from './types';

export interface FontSchemaEditorProps {
    initialValue?: FontSchema;
    onChange: (value?: FontSchema) => void;
}

export const FontSchemaEditor = ({ initialValue, onChange }: FontSchemaEditorProps) => {
    const [heading, setHeading] = useState<FontAsset | undefined>(initialValue?.heading);
    const [subheading, setSubheading] = useState<FontAsset | undefined>(initialValue?.subheading);
    const [body, setBody] = useState<FontAsset | undefined>(initialValue?.body);

    useUpdateEffect(() => {
        const newSchema: FontSchema = {};
        if (heading) {
            heading.family = heading.family.trim();
            newSchema.heading = heading;
        }

        if (subheading) {
            subheading.family = subheading.family.trim();
            newSchema.subheading = subheading;
        }

        if (body) {
            body.family = body.family.trim();
            newSchema.body = body;
        }

        if (Object.keys(newSchema).length > 0) {
            onChange(newSchema);
        } else {
            onChange(undefined);
        }
    }, [heading, subheading, body, onChange]);

    return (
        <Control spacing="compact">
            <FontInput label="Heading" initialValue={heading} onChange={setHeading} />
            <FontInput label="Subheading" initialValue={subheading} onChange={setSubheading} />
            <FontInput label="Body" initialValue={body} onChange={setBody} />
        </Control>
    );
};
